import React from 'react';
import { useLocation } from 'react-router-dom';
import { isValidWebLinkRoute } from '../../utils/helpers/urlValidator';
import InvalidProjectScreen from './InvalidProjectScreen';
import ErrorScreen1 from '../../assets/images/ErrorScreen1.png';

/**
 * Component that handles invalid weblink routes
 * Shows InvalidProjectScreen if the route is not a valid weblink route
 * Valid routes: '/dashboard-resp', '/sign-up', '/login-Resp', '/enter-otp'
 */
const InvalidRouteHandler = ({ children }) => {
  const location = useLocation();
  
  const pathname = location.pathname;
  const search = location.search; // Query parameters
  
  // Valid weblink routes
  const validWeblinkRoutes = ['/dashboard-resp', '/sign-up', '/login-Resp', '/enter-otp'];
  
  // Check if route is not in the valid list
  const isInvalidRoute = !validWeblinkRoutes.includes(pathname);
  
  // Check if route has query parameters (suggesting it's meant to be a weblink)
  // location.search already includes '?' if params exist, or is empty string if not
  const hasQueryParams = search && search.length > 0;
  
  // Check if route looks similar to a valid weblink route (typo/variation)
  const looksLikeWeblinkRoute = validWeblinkRoutes.some(validRoute => {
    // Check for common typos or variations
    if (pathname.startsWith('/dashboard-res') && pathname !== '/dashboard-resp') {
      return true; // e.g., /dashboard-res, /dashboard-resp-anything
    }
    if (pathname.startsWith('/sign-u') && pathname !== '/sign-up') {
      return true; // e.g., /sign-u-anything
    }
    if (pathname.startsWith('/login-Re') && pathname !== '/login-Resp') {
      return true; // e.g., /login-Re-anything
    }
    if (pathname.startsWith('/enter-ot') && pathname !== '/enter-otp') {
      return true; // e.g., /enterot-anything
    }
    return false;
  });
  
  // Show invalid screen if route is not in valid list AND:
  // 1. Has query parameters (suggesting it's a weblink), OR
  // 2. Looks like a weblink route (typo/variation)
  if (isInvalidRoute && (hasQueryParams || looksLikeWeblinkRoute)) {
    return <InvalidProjectScreen backgroundImageUrl={ErrorScreen1} />;
  }
  
  // Otherwise, render children (or nothing if this is used as a route element)
  return children || null;
};

export default InvalidRouteHandler;

